import { CustomerServiceResponse } from './customer-service-response';

export class ChangePcpResponse {
    public ValidationMessage: string;
    public CustomerServiceRequestNote: CustomerServiceResponse;

}